import api from './api';

const contractsDashboardService = {
  // Get contracts dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/contracts-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching contracts dashboard stats:', error);
      throw error;
    }
  }
};

export default contractsDashboardService;

